import React from 'react';

import { Stack, useMantineTheme } from '@mantine/core';

import { EditorPaneViewSelector, type ViewSelectorProps } from '../../../components';
type Props = {
  children: React.ReactNode
} & ViewSelectorProps;

const EditorPaneContainer: React.FC<Props> = (props: Props) => {
  const { children, isFullScreen, position } = props;
  const { colors } = useMantineTheme();
  const borderString = `1px solid ${colors.gray[2]}`;

  const borderLeft = !isFullScreen && position === 'left' ? borderString : undefined;
  const borderRight = !isFullScreen && position === 'right' ? borderString : undefined;
  return <Stack gap={0} flex={1}>
    <EditorPaneViewSelector {...props} />
    <Stack
      gap={0}
      flex={1}
      h='100%'
      style={{
        borderLeft,
        borderRight
      }}
    >
      {children}
    </Stack>
  </Stack>;
};

export default EditorPaneContainer;
